export type LocationUnit = SearchedSpace | SearchedLockerCluster
export type LocationUnitId = { type: string; encryptedId: string }

export const isSpaceLocationUnit = (locationUnit: LocationUnit): locationUnit is SearchedSpace => {
  return locationUnit.type === 'space'
}

export const isLockerLocationUnit = (
  locationUnit: LocationUnit
): locationUnit is SearchedLockerCluster => {
  return locationUnit.type === 'locker_cluster' || locationUnit.type === 'pudo_locker'
}

export const getCoordinate = (locationUnit: LocationUnit): Location => {
  return locationUnit.location
}

// SearchResultの型
export type SearchResult = {
  locationUnits: LocationUnit[]
  total: number
}

/** GET /api/v2/search の space.map_marker。専用ピンがない store は null */
export type MapMarker = {
  code: string
  active_image_url: string
  inactive_image_url: string
}

// Spaceの型
export type SearchedSpace = {
  type: 'space'
  location: Location
  /** v2 search の space UUID（canonical /spaces リンク用） */
  id?: string
  encryptedId: string
  spaceType: number
  name: string
  enName: string
  mainImageUrl: string
  smallLockerNum: number
  largeLockerNum: number
  suitcaseSize: number
  averageRating: number
  subCategoryId: number
  bagSize: number
  isAvailable: boolean
  basicInfo: BasicInfo
  mapMarker: MapMarker | null
}

// LockerClusterの型
export type SearchedLockerCluster = {
  type: 'locker_cluster' | 'pudo_locker'
  location: Location
  /** v2 search の space UUID（canonical /spaces リンク用） */
  id?: string
  encryptedId: string
  name: string
  enName: string
  mainImageUrl: string
  smallLockerNum: number
  mediumLockerNum: number
  largeLockerNum: number
  averageRating: number
  smallLockerPrice: number
  mediumLockerPrice: number
  largeLockerPrice: number
  isAvailable: boolean
  basicInfo: BasicInfo
}

// BasicInfoの型
export type BasicInfo = {
  hasElevator: boolean
  canBookOnTheDay: boolean
  available24Hour: boolean
  hasCharge: boolean
  noSmoking: boolean
  availableInEnglish: boolean
  hasWifi: boolean
}

// Locationの型
export type Location = {
  latitude: number
  longitude: number
}
